import { Paper as MaterialPaper, withStyles } from '@material-ui/core';

export const Paper = withStyles({
  root: {
    borderRadius: 6,
    border: 'solid 2px #e6e6e6',
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
})(MaterialPaper);
